export const BOARD_FETCH_REQUESTED = 'BOARD_FETCH_REQUESTED'
export const BOARD_FETCH_SUCCESS = 'BOARD_FETCH_SUCCESS'
export const BOARD_FETCH_FAILED = 'BOARD_FETCH_FAILED'

export const BOARD_MEMBERS_FETCH_REQUESTED = 'BOARD_MEMBERS_FETCH_REQUESTED'
export const BOARD_MEMBERS_FETCH_SUCCESS = 'BOARD_MEMBERS_FETCH_SUCCESS'
export const BOARD_MEMBERS_FETCH_FAILED = 'BOARD_MEMBERS_FETCH_FAILED'

export const BOARD_UPDATE_RESPONSIBILITY_REQUESTED =
  'BOARD_UPDATE_RESPONSIBILITY_REQUESTED'
export const BOARD_UPDATE_RESPONSIBILITY_SUCCESS =
  'BOARD_UPDATE_RESPONSIBILITY_SUCCESS'
export const BOARD_UPDATE_RESPONSIBILITY_FAILED =
  'BOARD_UPDATE_RESPONSIBILITY_FAILED'

export const BOARD_PROCESSING_RESET = 'BOARD_PROCESSING_RESET'
